import React, { useState, useEffect } from 'react'
import useTitle from "../../../hooks/useTitle"
import {
    PlusIcon,
    MinusIcon,
    PencilSquareIcon,
  } from "@heroicons/react/24/outline"
import PulseLoader from "react-spinners/PulseLoader"
import EtContentEditorLight2 from "../../../utils/EtContentEditorLight2"
import EtBtnFormBasic from "../../../components/common/buttons/EtBtnFormBasic"
import { useNavigate } from "react-router"
import { useCreateNewUserImprintCapabilitiesSalesMutation, useGetUserImprintCapabilitiesSalessQuery } from './userImprintCapabilitiesSalessApiSlice'
import { useGetCapabilitiesSalesTypesQuery } from '../../capabilitiesSalesTypes/capabilitiesSalesTypesApiSlice'
import { produce } from "immer";

const EtUpdateUserImprintCapabilitiesSalesComp = ({
  userId, 
  userOrgId, 
  triggeringUrl, 
  onClose
}) => {
  // First Created - 22 Nov 2024
  // Author - Atul Pandey
  // Inherited from the EtCreateUserImprintCapabilitiesIndustry component

  // 0 - Set Page title & variables
  useTitle('User Imprint Cpabilities')


  // 1a - set page navigations and seed variables (these will be props)
  const navigate = useNavigate()
  
  // 1b - Initialize state variables for the editor key and value
  const [editorKey, setEditorKey] = useState("capabilitiesSalesDesc-" + Date.now())
  const [editorValue, setEditorValue] = useState("")
  const [showCreateUserImprintCapabilitiesSales, setShowCreateUserImprintCapabilitiesSales] = useState(false)
  const [selectedSales, setSelectedSales] = useState(null); // 20 Nov 2024

  // 2a - set the mutation to create the new user imprint capabilitiesSales data
  const [createNewUserImprintCapabilitiesSales, {
    isLoading,
    isSuccess,
    isError,
    error,
  }] = useCreateNewUserImprintCapabilitiesSalesMutation()

  // 2b - Get capability sales types
  const { data: salesTypesData} = useGetCapabilitiesSalesTypesQuery()
  const salesTypes = salesTypesData?.ids?.map(id => salesTypesData?.entities[id])
  console.log('Sales Types', salesTypes)

  // 2c - Group Sales Types by focus, domain, function, and tech area
  // const groupedSalesTypes = salesTypes?.reduce((result, type) => {
  //   const focus = type.capabilitiesTechAreaType?.capabilitiesFunctionType?.capabilitiesDomainType?.capabilitiesDomainFocus || "Other";
  //   const domainName = type.capabilitiesTechAreaType?.capabilitiesFunctionType?.capabilitiesDomainType?.capabilitiesDomainTypeName || "Unknown Domain";
  //   const functionName = type.capabilitiesTechAreaType?.capabilitiesFunctionType?.capabilitiesFunctionTypeName || "Unknown Function";
  //   const techAreaName = type.capabilitiesTechAreaType?.capabilitiesTechAreaTypeName || "Unknown TechArea";
  
  //   if (!result[focus]) {
  //     result[focus] = {};
  //   }
  
  //   if (!result[focus][domainName]) {
  //     result[focus][domainName] = {};
  //   }
  
  //   if (!result[focus][domainName][functionName]) {
  //     result[focus][domainName][functionName] = {};
  //   }
  
  //   if (!result[focus][domainName][functionName][techAreaName]) {
  //     result[focus][domainName][functionName][techAreaName] = [];
  //   }
  
  //   result[focus][domainName][functionName][techAreaName].push(type);
  
  //   return result;
  //   }, {}) || {};
  
  //   console.log('groupedSalesTypes', groupedSalesTypes);

  // 2d - Get existing capabilities sales Data from the backend
  const { data: userImprintCapabilitiesSalesData} = useGetUserImprintCapabilitiesSalessQuery()
  const userImprintCapabilitiesSaless = userImprintCapabilitiesSalesData?.ids
  ?.map(id => userImprintCapabilitiesSalesData?.entities[id])
  ?.filter(item=> item.userId._id === userId && item.userOrgId._id === userOrgId) || []
  console.log('userImprintCapabilties Sales', userImprintCapabilitiesSaless)

  // 2e - Update the selectedSales state value based on the incoming data
  useEffect(() => {
    if (userImprintCapabilitiesSaless?.length > 0) {
      setSelectedSales(userImprintCapabilitiesSaless[0]);
    }
  }, [userImprintCapabilitiesSaless]);
  
  // 3a - Initialize state variables for the form data
  const [formData, setFormData] = useState({
    userImprintCapabilitiesSalesName: "",
    userImprintCapabilitiesSalesDesc: "",
    userImprintCapabilitiesSalesStats: [
      {
        salesType:null,
        yearsOfExperience: 0,
        proficiencyLevel: "Yet to Begin",
        numberOfEngagements:0,
        certifications: [
          {
            certificationName: "",
            certificationDesc: "",
            certificationDate: "",
            validTill: "",
          }
        ],
        recognitions: [
          {
            recognitionName: "",
            recognitionDesc: "",
            recognitionOrg: "",
            recognitionDate: "",
          }
        ],
      }
    ],
    userImprintCapabilitiesSalesSelfNotes: [],
    aboutMe: "",
    pic: "",
  })

  // 3b - Use Effect to populate the formData based on the data from the backend
  useEffect(() => {
    if (selectedSales) {
      setFormData(
        produce((draft) => {
          draft.userImprintCapabilitiesSalesName = selectedSales.userImprintCapabilitiesSalesName || "";
          draft.userImprintCapabilitiesSalesDesc = selectedSales.userImprintCapabilitiesSalesDesc || "";
          draft.userImprintCapabilitiesSalesStats = selectedSales.userImprintCapabilitiesSalesStats?.map((stat) => ({
            ...stat,
            salesType: stat.salesType?._id || null,
          })) || [
            {
              salesType: null,
              yearsOfExperience: 0,
              proficiencyLevel: "Yet to Begin",
              numberOfEngagements: 0,
              certifications: [],
              recognitions: [],
            },
          ];
          draft.userImprintCapabilitiesSalesSelfNotes = selectedSales.userImprintCapabilitiesSalesSelfNotes || [];
          draft.aboutMe = selectedSales.aboutMe || "";
          draft.pic = "";
        })
      );
      setEditorValue(selectedSales.userImprintCapabilitiesSalesDesc || "");
    }
  }, [selectedSales]);
 
  // 5 - Handle form field changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;
  setFormData(
    produce((draft) => {
      if (name === "pic") {
        draft.pic = files[0];
      } else {
        draft[name] = value;
      }
    })
  );
  }

  // 5a - Handle editor value change
  const handleEditorChange = (content) => {
    setEditorValue(content)
    setFormData(prevState => ({ ...prevState, userImprintCapabilitiesSalesDesc: content }))
  }

  // 5b - Generic Handle Add Field Sales
  const handleAdd = (fieldName, newItem) => {
    setFormData(prevState => ({
      ...prevState,
      [fieldName]: [...prevState[fieldName], newItem]
    }))
  }

  // 5c - Generic Handle Remove Field Sales
  const handleRemove = (fieldName, index) => {
    setFormData(prevState => ({
      ...prevState,
      [fieldName]: prevState[fieldName].filter((_, i) => i !== index)
    }))
  }

  // 5d - Sales to convert pic to Base64
  const convertPicToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    }); 
 

  // 6 - Form submit logic
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Step 1: Handle the pic conversion separately
    const picBase64 = formData.pic ? await convertPicToBase64(formData.pic) : undefined;
  
    // Step 2: Use Immer to produce an immutable copy
    const payload = produce(formData, (draft) => {
      draft.userId = userId;
      draft.userOrgId = userOrgId;
      // Trim and clean up values within the draft object
      draft.userImprintCapabilitiesSalesName =
        draft.userImprintCapabilitiesSalesName?.trim() || undefined;
      draft.userImprintCapabilitiesSalesDesc =
        draft.userImprintCapabilitiesSalesDesc?.trim() || undefined;
  
      draft.userImprintCapabilitiesSalesStats.forEach((stat) => {
        stat.certifications = stat.certifications.filter((cert) =>
          Object.values(cert).some((value) => value !== "")
        );
        stat.recognitions = stat.recognitions.filter((rec) =>
          Object.values(rec).some((value) => value !== "")
        );
      });
  
      draft.userImprintCapabilitiesSalesSelfNotes =
        draft.userImprintCapabilitiesSalesSelfNotes.filter(
          (note) => note.userImprintCapabilitiesSalesSelfNoteText.trim() !== ""
        );
      draft.aboutMe = draft.aboutMe?.trim() || undefined;
      // Add the Base64 pic separately
      draft.pic = picBase64;
      
    });
  
    try {
      // Call the mutation
      await createNewUserImprintCapabilitiesSales(payload).unwrap();
  
      // Reset form and navigate on success
      setFormData({
        userImprintCapabilitiesSalesName: "",
        userImprintCapabilitiesSalesDesc: "",
        userImprintCapabilitiesSalesStats: [
          {
            salesType: null,
            yearsOfExperience: 0,
            proficiencyLevel: "Yet to Begin",
            numberOfEngagements: 0,
            certifications: [],
            recognitions: [],
          },
        ],
        userImprintCapabilitiesSalesSelfNotes: [],
        aboutMe: "",
        pic: "",
      });
      if (onClose) {
        onClose(); // 21 Nov 2024
      } else{
        navigate(triggeringUrl || '/userMagicHome');
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  
  // 7 - Reset form upon successful submission
  useEffect(() => {
    if(isSuccess) {
      setFormData({
        userImprintCapabilitiesSalesName: "",
      userImprintCapabilitiesSalesDesc: "",
      userImprintCapabilitiesSalesStats: [
        {
          salesType:null,
          yearsOfExperience: 0,
          proficiencyLevel: "Yet to Begin",
          numberOfEngagements:0,
          certifications: [
            {
              certificationName: "",
              certificationDesc: "",
              certificationOrg:"",
              certificationDate: "",
              validTill: "",
            }
          ],
          recognitions: [
            {
              recognitionName: "",
              recognitionDesc: "",
              recognitionOrg: "",
              recognitionDate: "",
            }
          ],
        }
      ],
      userImprintCapabilitiesSalesSelfNotes: [],
      aboutMe: "",
      pic: "",
      })
      // setShowCreateUserImprintCapabilitiesSales(false)
      if (onClose) {
        onClose(); // 21 Nov 2024
      } else{
        navigate(triggeringUrl || '/userMagicHome');
      }
    }
  
    },[isSuccess,navigate])

  // 8 - Handle Cancel
  const handleCancel = () => {
    // setShowCreateUserImprintCapabilitiesSales(false)
    if (onClose) {
      onClose(); // 21 Nov 2024
    } else{
      navigate(triggeringUrl || '/userMagicHome');
    }
  }

  // 9 - Handle Clear
  const handleClear = () => {
    setFormData(
      produce((draft) => {
        draft.userImprintCapabilitiesSalesName = "";
        draft.userImprintCapabilitiesSalesDesc = "";
        draft.userImprintCapabilitiesSalesStats = [
          {
            salesType: null,
            yearsOfExperience: 0,
            proficiencyLevel: "Yet to Begin",
            numberOfEngagements: 0,
            certifications: [],
            recognitions: [],
          },
        ];
        draft.userImprintCapabilitiesSalesSelfNotes = [];
        draft.aboutMe = "";
        draft.pic = "";
      })
    );
  };
 
  return (
    <div className="mx-auto m-1 p-1 bg-white rounded shadow-md shadow-black">
      {isLoading && <PulseLoader color={"#ea580c"} />}
      {isError && (
        <p className="text-orange-700 font-semi-bold py-2">
          {error?.data?.message}
        </p>
      )}

      <p className="p-1 m-1 font-bold font-poppins text-xl">Create User Imprint Capabilities - Sales</p>

      
      <form onSubmit={handleSubmit} className="m-1 p-1 text-xs font-poppins">
      {/* 1. userImprintCapabilitiesSalesName */}
      <div id="userImprintCapabilitiesSalesName" className="bg-gray-100 rounded p-1 m-1">
        <label htmlFor="userImprintCapabilitiesSalesName" className="block text-gray-600 text-sm font-bold mb-1">
          Capability Name (Optional)
        </label>
        <input
          type="text"
          name="userImprintCapabilitiesSalesName"
          placeholder="Enter a headline or title"
          value={formData.userImprintCapabilitiesSalesName}
          onChange={handleChange}
          className="w-full rounded p-2 border border-gray-300 focus:ring-orange-500 focus:border-orange-500"
        />
      </div>
      
      {/* 2. userImprintCapabilitiesSalesDesc */}
      <div id="userImprintCapabilitiesSalesDesc" className="bg-gray-100 rounded p-1 m-1">
        <label htmlFor="userImprintCapabilitiesSalesDesc" className="block text-gray-600 text-sm font-bold mb-1">
          Capability Description
        </label>
        <EtContentEditorLight2
          value={editorValue}
          handleChange={handleEditorChange}
          placeholderText="Write your capability description here!"
          editorKey={editorKey}
        />
      </div>

      {/* Sales Stats Section */}

      <div className="flex justify-between items-center m-1 p-1">
        <p className="font-bold text-sm mb-2">Sales Stats</p>
        <div className='flex justify-start items-center'>
          <p className='text-xs font-bold mx-1 px-1'>Add</p>
          <button
            type="button"
            className="bg-lime-600 hover:bg-lime-700 text-white text-xs font-bold m-1 p-1 rounded"
            onClick={() => {
              setFormData(
                produce((draft) => {
                  draft.userImprintCapabilitiesSalesStats.push({
                    salesType: null,
                    yearsOfExperience: 0,
                    proficiencyLevel: "Yet to Begin",
                    numberOfEngagements: 0,
                    certifications: [],
                    recognitions: [],
                  });
                })
              );
            }}
          >
            <PlusIcon className="h-4 w-4 inline" /> 
          </button>
        </div>
        
      </div>

      {formData.userImprintCapabilitiesSalesStats.map((stat, statIndex) => (
          <div key={statIndex} className="border rounded p-2 m-2 bg-gray-50">
            <div className="flex justify-between items-center mb-2">
                <p className="font-bold text-sm mb-2">Sales Stat {statIndex + 1}</p>
                <div className='flex justify-start items-center'>
                  <p className='text-xs font-bold mx-1 px-1'>Remove</p>
                  <button
                    type="button"
                    className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold m-1 p-1 rounded"
                    onClick={() => {
                      setFormData(
                        produce((draft) => {
                          draft.userImprintCapabilitiesSalesStats.splice(statIndex, 1);
                        })
                      );
                    }}
                  >
                    <MinusIcon className="h-4 w-4 inline" /> 
                  </button>
                </div>
                
            </div>

            {/* Sales Type Dropdown */}
            <div id={`salesType-${statIndex}`} className="flex justify-between items-center bg-gray-100 rounded p-1 m-1">
              <label htmlFor={`salesType-${statIndex}`} className="text-gray-600 text-sm font-bold w-1/3">
                Sales Type
              </label>
                <select
                id={`salesType-${statIndex}`}
                value={stat.salesType || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData((prevState) => {
                    const updatedStats = [...prevState.userImprintCapabilitiesSalesStats];
                    updatedStats[statIndex].salesType = value;
                    return { ...prevState, userImprintCapabilitiesSalesStats: updatedStats };
                  });
                }}
                className="w-2/3 rounded p-2 border border-gray-300 focus:outline-none"
              >
                <option value="" disabled>
                  Select Sales Type
                </option>
                {salesTypes?.map((type) => (
                  <option key={type._id} value={type._id}>
                    {type.capabilitiesSalesTypeName}
                  </option>
                ))}
                </select>
               {/* <select
                    id={`salesType-${statIndex}`}
                    value={stat.salesType || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData((prevState) => {
                        const updatedStats = [...prevState.userImprintCapabilitiesSalesStats];
                        updatedStats[statIndex].salesType = value;
                        return { ...prevState, userImprintCapabilitiesSalesStats: updatedStats };
                      });
                    }}
                    className="w-full rounded p-2 border border-gray-300 focus:outline-none"
                  >
                    <option value="" disabled>
                      Select Tech Stack Type
                    </option>
                    {Object.entries(groupedSalesTypes)?.map(([focus, domains]) =>
                      Object.entries(domains).flatMap(([domainName, functions]) =>
                        Object.entries(functions).flatMap(([functionName, techAreas]) =>
                          Object.entries(techAreas).map(([techAreaName, saless]) => (
                            <optgroup
                              key={`${focus}-${domainName}-${functionName}-${techAreaName}`}
                              label={`${focus} - ${domainName} - ${functionName} - ${techAreaName}`}
                            >
                              {saless.map((stack) => (
                                <option key={stack._id} value={stack._id}>
                                  {stack.capabilitiesSalesTypeName}
                                </option>
                              ))}
                            </optgroup>
                          ))
                        )
                      )
                    )}
                  </select> */}

            </div>

              {/* Years of Experience */}
              <div id={`yearsOfExperience-${statIndex}`} className="flex justify-between items-center bg-gray-100 rounded p-1 m-1">
                <label htmlFor={`yearsOfExperience-${statIndex}`} className="text-gray-600 text-sm font-bold w-1/3">
                  Years of Experience
                </label>
                <input
                  type="number"
                  id={`yearsOfExperience-${statIndex}`}
                  name="yearsOfExperience"
                  min="0"
                  value={stat.yearsOfExperience || 0}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10) || 0;
                    setFormData(
                      produce((draft) => {
                        draft.userImprintCapabilitiesSalesStats[statIndex].yearsOfExperience = value;
                      })
                    );
                  }}
                  className="w-2/3 rounded p-2 border border-gray-300 focus:outline-none"
                />
              </div>

              {/* Proficiency Level */}
              <div id={`proficiencyLevel-${statIndex}`} className="flex justify-between items-center bg-gray-100 rounded p-1 m-1">
                <label htmlFor={`proficiencyLevel-${statIndex}`} className="text-gray-600 text-sm font-bold w-1/3">
                  Proficiency Level
                </label>
                <select
                  id={`proficiencyLevel-${statIndex}`}
                  name="proficiencyLevel"
                  value={stat.proficiencyLevel || "Yet to Begin"}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData(
                      produce((draft) => {
                        draft.userImprintCapabilitiesSalesStats[statIndex].proficiencyLevel = value;
                      })
                    );
                  }}
                  className="w-2/3 rounded p-2 border border-gray-300 focus:outline-none"
                >
                  <option value="Yet to Begin">Yet to Begin</option>
                  <option value="Beginner">Beginner</option>
                  <option value="Advanced">Advanced</option>
                  <option value="Pro">Pro</option>
                  <option value="Expert">Expert</option>
                  <option value="Leader">Leader</option>
                </select>
              </div>

              {/* Number of Engagements */}
              <div id={`numberOfEngagements-${statIndex}`} className="flex justify-between items-center bg-gray-100 rounded p-1 m-1">
                <label htmlFor={`numberOfEngagements-${statIndex}`} className="text-gray-600 text-sm font-bold w-1/3">
                  Number of Engagements
                </label>
                <input
                  type="number"
                  id={`numberOfEngagements-${statIndex}`}
                  name="numberOfEngagements"
                  min="0"
                  value={stat.numberOfEngagements || 0}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10) || 0;
                    setFormData(
                      produce((draft) => {
                        draft.userImprintCapabilitiesSalesStats[statIndex].numberOfEngagements = value;
                      })
                    );
                  }}
                  className="w-2/3 rounded p-2 border border-gray-300 focus:outline-none"
                />
              </div>

              {/* Certifications Section */}
              <div id={`certifications-${statIndex}`} className="border rounded p-2 m-2 bg-gray-50">
                <div className="flex justify-between items-center mb-2">
                    <p className="font-bold text-sm">Certifications</p>
                    <div className='flex justify-start items-center'>
                      <p className='text-xs font-bold mx-1 px-1'>Add</p>
                      <button
                          type="button"
                          className="bg-lime-600 hover:bg-lime-700 text-white text-xs font-bold m-1 p-1 rounded"
                          onClick={() => {
                            setFormData(
                              produce((draft) => {
                                draft.userImprintCapabilitiesSalesStats[statIndex].certifications.push({
                                  certificationName: "",
                                  certificationDesc: "",
                                  certificationOrg:"",
                                  certificationDate: "",
                                  validTill: "",
                                });
                              })
                            );
                          }}
                        >
                        <PlusIcon className="h-4 w-4 inline" />
                      </button>

                    </div>
                  
                </div>

                {/* Certifications List */}
                {stat.certifications.map((cert, certIndex) => (
                  <div key={`${statIndex}-${certIndex}`} className="p-2 border rounded mb-2 bg-white">
                    <div className="flex justify-between items-center">
                        <p className="font-bold text-sm">Certification {certIndex + 1}</p>
                        <div className='flex justify-start items-center'>
                            <p className='text-xs font-bold mx-1 px-1'>Remove</p>
                            <button
                            type="button"
                            className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold m-1 p-1 rounded"
                            onClick={() => {
                              setFormData(
                                produce((draft) => {
                                  draft.userImprintCapabilitiesSalesStats[statIndex].certifications.splice(certIndex, 1);
                                })
                              );
                            }}
                          >
                            <MinusIcon className="h-4 w-4 inline" />
                          </button>
                        </div>
                      
                    </div>

                    {/* Certification Fields */}
                    <input
                      type="text"
                      placeholder="Certification Name"
                      value={cert.certificationName}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData(
                          produce((draft) => {
                            draft.userImprintCapabilitiesSalesStats[statIndex].certifications[certIndex].certificationName = value;
                          })
                        );
                      }}
                      className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300 mt-2"
                    />

                    <EtContentEditorLight2
                      value={cert.certificationDesc}
                      handleChange={(content) => {
                        setFormData(
                          produce((draft) => {
                            draft.userImprintCapabilitiesSalesStats[statIndex].certifications[certIndex].certificationDesc = content;
                          })
                        );
                      }}
                      placeholderText="Write certification details here..."
                      editorKey={`certificationDesc-${statIndex}-${certIndex}`}
                    />

                    <div className="flex justify-between items-center">
                      
                      <div className="flex flex-col m-1 p-1 w-full">
                        <label
                          htmlFor={`certificationOrg-${statIndex}-${certIndex}`}
                          className="text-gray-600 text-sm font-bold"
                        >
                          Certifying Organization:
                        </label>
                        <input
                          type="text"
                          id={`certificationOrg-${statIndex}-${certIndex}`}
                          value={cert.certificationOrg || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData(
                              produce((draft) => {
                                draft.userImprintCapabilitiesSalesStats[statIndex].certifications[certIndex].certificationOrg = value;
                              })
                            );
                          }}
                          className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300"
                        />
                      </div>

                      <div className="flex flex-col m-1 p-1 w-full">
                        <label
                          htmlFor={`certificationDate-${statIndex}-${certIndex}`}
                          className="text-gray-600 text-sm font-bold"
                        >
                          Certification Date
                        </label>
                        <input
                          type="date"
                          id={`certificationDate-${statIndex}-${certIndex}`}
                          value={cert.certificationDate ? cert.certificationDate.split('T')[0] : ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData(
                              produce((draft) => {
                                draft.userImprintCapabilitiesSalesStats[statIndex].certifications[certIndex].certificationDate = value;
                              })
                            );
                          }}
                          className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300"
                        />
                      </div>

                      <div className="flex flex-col m-1 p-1 w-full">
                        <label
                          htmlFor={`validTill-${statIndex}-${certIndex}`}
                          className="text-gray-600 text-sm font-bold"
                        >
                          Valid Till
                        </label>
                        <input
                          type="date"
                          id={`validTill-${statIndex}-${certIndex}`}
                          value={cert.validTill ? cert.validTill.split('T')[0] : ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData(
                              produce((draft) => {
                                const cert = draft.userImprintCapabilitiesSalesStats[statIndex].certifications[certIndex];
                                if (new Date(value) >= new Date(cert.certificationDate)) {
                                  cert.validTill = value;
                                }
                              })
                            );
                          }}
                          className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Recognitions Section */}
              <div id={`recognitions-${statIndex}`} className="border rounded p-2 m-2 bg-gray-50">
                <div className="flex justify-between items-center mb-2">
                    <p className="font-bold text-sm">Recognitions</p>
                    <div className='flex justify-start items-center'>
                        <p className='text-xs font-bold mx-1 px-1'>Add</p>
                        <button
                          type="button"
                          className="bg-lime-600 hover:bg-lime-700 text-white text-xs font-bold m-1 p-1 rounded"
                          onClick={() => {
                            setFormData(
                              produce((draft) => {
                                draft.userImprintCapabilitiesSalesStats[statIndex].recognitions.push({
                                  recognitionName: "",
                                  recognitionDesc: "",
                                  recognitionOrg: "",
                                  recognitionDate: "",
                                });
                              })
                            );
                          }}
                        >
                          <PlusIcon className="h-4 w-4 inline" />
                        </button>
                    </div>
                  
                </div>

                {/* Recognitions List */}
                {stat.recognitions.map((rec, recIndex) => (
                  <div key={`${statIndex}-${recIndex}`} className="p-2 border rounded mb-2 bg-white">
                    <div className="flex justify-between items-center">
                        <p className="font-bold text-sm">Recognition {recIndex + 1}</p>
                        <div className='flex justify-start items-center'>
                            <p className='text-xs font-bold mx-1 px-1'>Remove</p>
                            <button
                            type="button"
                            className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold m-1 p-1 rounded"
                            onClick={() => {
                              setFormData(
                                produce((draft) => {
                                  draft.userImprintCapabilitiesSalesStats[statIndex].recognitions.splice(recIndex, 1);
                                })
                              );
                            }}
                          >
                            <MinusIcon className="h-4 w-4 inline" />
                          </button>
                        </div>

                    </div>

                    {/* Recognition Fields */}
                    <input
                      type="text"
                      placeholder="Recognition Name"
                      value={rec.recognitionName}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData(
                          produce((draft) => {
                            draft.userImprintCapabilitiesSalesStats[statIndex].recognitions[recIndex].recognitionName = value;
                          })
                        );
                      }}
                      className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300 mt-2"
                    />

                    <EtContentEditorLight2
                      value={rec.recognitionDesc}
                      handleChange={(content) => {
                        setFormData(
                          produce((draft) => {
                            draft.userImprintCapabilitiesSalesStats[statIndex].recognitions[recIndex].recognitionDesc = content;
                          })
                        );
                      }}
                      placeholderText="Write recognition details here..."
                      editorKey={`recognitionDesc-${statIndex}-${recIndex}`}
                    />

                    <div className="flex justify-between items-center">
                      <div className="flex flex-col m-1 p-1 w-full">
                        <label
                          htmlFor={`recognitionOrg-${statIndex}-${recIndex}`}
                          className="text-gray-600 text-sm font-bold"
                        >
                          Recognizing Org
                        </label>
                        <input
                          type="text"
                          id={`recognitionOrg-${statIndex}-${recIndex}`}
                          placeholder="Enter recognizing organization"
                          value={rec.recognitionOrg}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData(
                              produce((draft) => {
                                draft.userImprintCapabilitiesSalesStats[statIndex].recognitions[recIndex].recognitionOrg = value;
                              })
                            );
                          }}
                          className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300"
                        />
                      </div>

                      <div className="flex flex-col m-1 p-1 w-full">
                        <label
                          htmlFor={`recognitionDate-${statIndex}-${recIndex}`}
                          className="text-gray-600 text-sm font-bold"
                        >
                          Recognition Date
                        </label>
                        <input
                          type="date"
                          id={`recognitionDate-${statIndex}-${recIndex}`}
                          value={rec.recognitionDate ? rec.recognitionDate.split('T')[0] : ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData(
                              produce((draft) => {
                                draft.userImprintCapabilitiesSalesStats[statIndex].recognitions[recIndex].recognitionDate = value;
                              })
                            );
                          }}
                          className="w-full rounded p-2 border border-gray-300 focus:outline-none focus:ring focus:ring-orange-300"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
          </div>
      ))}

      {/* Notes Section */}
      <div id="selfNotes" className="border rounded p-2 m-2 bg-gray-50">
        <div className="flex justify-between items-center mb-2">
            <p className="font-bold text-sm">Notes</p>
            <div className='flex justify-start items-center'>
                <p className='text-xs font-bold mx-1 px-1'>Add</p>
                <button
                type="button"
                className="bg-lime-600 hover:bg-lime-700 text-white text-xs font-bold m-1 p-1 rounded"
                onClick={() => {
                  setFormData(
                    produce((draft) => {
                      draft.userImprintCapabilitiesSalesSelfNotes.push({
                        userImprintCapabilitiesSalesSelfNoteText: "",
                        userImprintCapabilitiesSalesSelfNoteDate: new Date().toISOString(),
                        userImprintCapabilitiesSalesSelfNoteUpdateDate: null,
                      });
                    })
                  );
                }}
              >
                <PlusIcon className="h-4 w-4 inline" />
              </button>
            </div>
          
        </div>

        {formData.userImprintCapabilitiesSalesSelfNotes?.map((note, noteIndex) => (
          <div key={noteIndex} className="p-2 border rounded mb-2 bg-white">
            <div className="flex justify-between items-center">
                  <p className="font-bold text-sm">Self Note: {noteIndex + 1}</p>
              <div className='flex justify-start items-center'>
                  <p className='text-xs font-bold mx-1 px-1'>Remove</p>
                  <button
                    type="button"
                    className="bg-red-500 hover:bg-red-600 text-white text-xs font-bold m-1 p-1 rounded"
                    onClick={() => {
                      setFormData(
                        produce((draft) => {
                          draft.userImprintCapabilitiesSalesSelfNotes.splice(noteIndex, 1);
                        })
                      );
                    }}
                  >
                    <MinusIcon className="h-4 w-4 inline" />
                  </button>
              </div>
              
            </div>

            {/* Note Text */}
            <EtContentEditorLight2
              value={note.userImprintCapabilitiesSalesSelfNoteText}
              handleChange={(content) => {
                setFormData(
                  produce((draft) => {
                    draft.userImprintCapabilitiesSalesSelfNotes[noteIndex].userImprintCapabilitiesSalesSelfNoteText = content;
                    draft.userImprintCapabilitiesSalesSelfNotes[noteIndex].userImprintCapabilitiesSalesSelfNoteUpdateDate = new Date().toISOString();
                  })
                );
              }}
              placeholderText="Write your note here..."
              editorKey={`note-${noteIndex}`}
            />

            {/* Note Date (Read-Only) */}
            <p className="text-xs text-gray-500 mt-2">
              Created on: {new Date(note.userImprintCapabilitiesSalesSelfNoteDate).toLocaleDateString()}
              {note.userImprintCapabilitiesSalesSelfNoteUpdateDate && (
                <span>
                  , Updated on: {new Date(note.userImprintCapabilitiesSalesSelfNoteUpdateDate).toLocaleDateString()}
                </span>
              )}
            </p>
          </div>
        ))}
      </div>

      <div id="actions" className="bg-white m-1 px-1 py-3 rounded">
              <EtBtnFormBasic
                name={"Update"}
                type={"create"}
                handleClick={handleSubmit}
              />
              <EtBtnFormBasic
                name={"Clear"}
                type={"clear"}
                handleClick={handleClear}
              />
              <EtBtnFormBasic
                name={"Cancel"}
                type={"cancel"}
                handleClick={handleCancel}
              />
            </div>

    </form>

    </div>
  )
}

export default EtUpdateUserImprintCapabilitiesSalesComp